import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FinnairTravelEndpoint } from '@fcom/dapi/api/models/finnair-travel-endpoint';
import { LocationInfoMap } from '@fcom/dapi/interfaces/itinerary.interface';

@Component({
  selector: 'fin-itinerary-timeline-leg-endpoint',
  styleUrls: ['../itinerary.scss', '../arrow-block.scss'],
  templateUrl: './leg-endpoint.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ItineraryTimelineLegEndpointComponent {
  @Input()
  endpoint: FinnairTravelEndpoint;

  @Input()
  locations: LocationInfoMap;

  @Input()
  oldEndpointDateTime: string;

  @Input()
  oldEndpointLocationCode: string;
}
